export default __webpack_public_path__ + "static/media/Banner.2f6f8ddc.png";